<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="订单编号" prop="orderNo">
        <el-input v-model="search.orderNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单状态" prop="status">
        <el-select v-model="search.status" placeholder="请选择" clearable>
          <!-- <el-option v-for="item in OldMachineRecoveryStatus" :key="item.value" :label="item.label" :value="item.value"> </el-option> -->
          <el-option v-for="(item, index) in OldMachineRecoveryStatus" :key="index" :label="item.description" :value="item.enumCode"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回收子状态" prop="recyclingStatus" v-show="search.status == '4'">
        <el-select v-model="search.recyclingStatus" placeholder="请选择" clearable>
          <el-option v-for="item in recyclingStatusOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="网点编号" prop="networkNo">
        <el-input v-model="search.networkNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="网点名称" prop="field">
        <el-input v-model="search.field" placeholder="请输入"></el-input>
      </el-form-item> -->
      <el-form-item label="省份" prop="province">
        <el-input v-model="search.province" placeholder="请输入" clearable></el-input>

        <!-- <el-select
          v-model="search.province"
          placeholder="请选择"
          clearable
          style="width:100%"
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.sfid"
            :label="item.sfen"
            :value="item.sfen"
            style="width:100%"
          >
          </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="城市" prop="city">
        <el-input v-model="search.city" placeholder="请输入" clearable></el-input>
        <!--
        <el-select
          v-model="search.city"
          placeholder="请选择"
          clearable
          style="width:100%"
          :disabled="!search.province"
          @change="getTblCounty"
        >
          <el-option
            v-for="item in cityList"
            :key="item.ciid"
            :label="item.city"
            :value="item.city"
            style="width:100%"
          >
          </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="区" prop="county">
        <el-input v-model="search.county" placeholder="请输入" clearable></el-input>
        <!-- <el-select
          v-model="search.county"
          placeholder="请选择"
          clearable
          style="width:100%"
          :disabled="!search.city"
        >
          <el-option
            v-for="item in countyList"
            :key="item.ciid"
            :label="item.county"
            :value="item.county"
            style="width:100%"
          >
          </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="联系人" prop="contact">
        <el-input v-model="search.contact" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="tel">
        <el-input v-model="search.tel" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="承运商" prop="carrierNo">
        <el-select v-model="search.carrierNo" placeholder="请选择" clearable style="width: 100%" :disabled="partnershipType !== 3">
          <el-option v-for="item in carrierOption" :key="item.carrierNo" :label="item.carrierName" :value="item.carrierNo"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="归集仓库" prop="warehouseNo">
        <el-select v-model="search.warehouseNo" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="(item, key) in warehouseList" :key="key" :label="item.warehouseName" :value="item.warehouseNo" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属区域" prop="regionName">
        <el-input v-model="search.regionName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="客户出库单" prop="outboundNo">
        <el-input v-model="search.outboundNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="回收人员" prop="recoveryWorkerName">
        <el-input v-model="search.recoveryWorkerName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="承运商所属组织" prop="carrierOrg">
        <el-input v-model="search.carrierOrg" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="field">
        <el-date-picker v-model="createdTime" clearable type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="预约时间" prop="field">
        <el-date-picker v-model="appointTime" type="daterange" clearable value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="回收完成时间" prop="field">
        <el-date-picker v-model="completeTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
      <el-button size="medium" @click="resetForm">重置</el-button>
      <el-button size="medium" @click="exportExcel">导出</el-button>
      <!-- <el-button size="medium" @click="downloadSettlement" :loading="downloadSettlementLoading"
        >{{downloadSettlementLoading?'结算单导出中...':'结算单导出'}}</el-button
      > -->
      <el-button size="medium" @click="exportOutboundNoExcel" :loading="downloadOutboundLoading">{{ downloadOutboundLoading ? '出库单导出中...' : '导出出库单' }}</el-button>
      <el-button type="primary" size="medium" @click="OldMachineBatchHangupExcel()" :loading="HangupExcelBtnLoading">批量挂起模板下载</el-button>
      <div class="batch-storage-button">
        <file-upload ref="fileupload" @addUpload="handleHangupImport" :title="'批量挂起导入'" />
      </div>
      <el-button type="primary" size="medium" @click="OldMachineBatchActivateExcel()" :loading="ActivateExcelBtnLoading">批量激活模板下载</el-button>
      <div class="batch-storage-button">
        <file-upload ref="fileupload" @addUpload="handleActivateImport" :title="'批量激活导入'" />
      </div>
    </div>
    <div>
      <el-tabs v-model="statusText" @tab-click="handleSearch">
        <el-tab-pane label="全部" :name="null"></el-tab-pane>
        <el-tab-pane v-for="item in tabsOption" :key="item.value" :label="item.label" :name="item.value"></el-tab-pane>
        <el-tab-pane label="超时未回收" :name="null"></el-tab-pane>
        <el-tab-pane label="3日内超时" :name="null"></el-tab-pane>
      </el-tabs>
    </div>
    <el-table ref="checktableData" :data="list" v-loading="listLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="订单编号" prop="orderNo" width="160"></el-table-column>
      <el-table-column label="订单状态" prop="status" width="120">
        <template slot-scope="scope">{{ changeStatus(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="网点编号" prop="networkNo" width="80"></el-table-column>
      <el-table-column label="网点名称" prop="networkName" width="120"></el-table-column>
      <el-table-column label="客户出库单" prop="outboundNo" width="120"></el-table-column>
      <el-table-column label="回收人员" prop="recoveryWorkerName" width="120"></el-table-column>
      <el-table-column label="所属区域" prop="regionName" width="120"></el-table-column>
      <el-table-column label="下单旧机" prop="recoveryNum" width="120"></el-table-column>
      <el-table-column label="旧机实收" prop="actualCollectionNum" width="120"></el-table-column>
      <!-- <el-table-column
        label="下单连接管"
        prop="copperPipeAmount"
        width="120"
      ></el-table-column>
      <el-table-column
        label="实收连接管"
        prop="actualCopperPipe"
        width="120"
      ></el-table-column> -->
      <el-table-column label="旧机价值" prop="bondAmount" width="120"></el-table-column>
      <el-table-column label="扣款金额" prop="deductionAmount" width="120"></el-table-column>
      <el-table-column label="承运商" prop="carrierName" width="120"></el-table-column>
      <el-table-column label="承运商所属组织" prop="carrierOrg" width="120"></el-table-column>
      <el-table-column label="归集仓库" prop="warehouseName" width="120"></el-table-column>
      <el-table-column label="联系人" prop="contact" width="120"></el-table-column>
      <el-table-column label="联系电话" prop="tel" width="120"></el-table-column>
      <el-table-column label="省" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.province }}</template>
      </el-table-column>
      <el-table-column label="市" prop="city" width="120"></el-table-column>
      <el-table-column label="区" prop="county" width="120"></el-table-column>
      <el-table-column label="详细地址" prop="detailAddress" width="120"></el-table-column>
      <el-table-column label="创建时间" prop="createdDate" width="120">
        <template slot-scope="scope">{{ scope.row.createdDate | formatDateTimeDefault }}</template>
      </el-table-column>

      <el-table-column label="预约时间" prop="appointDate" width="200">
        <template slot-scope="scope"
          >{{ scope.row.appointStartDate | formatDateTimeDefault }} ~
          {{ scope.row.appointEndDate | formatDateTimeDefault }}
        </template>
      </el-table-column>
      <el-table-column label="派工时间" prop="appointDate" width="200">
        <template slot-scope="scope">{{ scope.row.dispatchDate | formatDateTimeDefault }} </template>
      </el-table-column>
      <el-table-column label="回收完成时间" prop="recoveryCompleteDate" width="120">
        <template slot-scope="scope">{{ scope.row.recoveryCompleteDate | formatDateTimeDefault }}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="280" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">查看</el-button>
          <el-button type="text" @click="goAdd(scope.row)" v-show="[1, 2, 3, 9].includes(Number(scope.row.status))">派车/改派</el-button>
          <el-button type="text" @click="goCar(scope.row)" v-show="Number(scope.row.status) == 5">车辆信息维护</el-button>
          <el-button type="text" @click="handleHangup(scope.row)" v-show="![6,7,8,10].includes(Number(scope.row.status))">挂起</el-button>
          <el-button type="text" @click="handleActivate(scope.row)" v-show="[10].includes(Number(scope.row.status))">激活</el-button>
          <!-- <el-button
            type="text"
            v-show="Number(scope.row.status) === 7"
            @click="downloadSettlementById(scope.row.orderNo)"
            >下载结算单</el-button
          > -->
          <!-- <el-button type="text" @click="goCancel(scope.row)">取消</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.currPage"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <appointmentDialog ref="AddDialogRef" @opera-success="getList"></appointmentDialog>
    <carDialog ref="carDialogRef" @opera-success="getList"></carDialog>
    <BatchAddMasterVue ref="batchAddMasterRef" @opera-success="getList"></BatchAddMasterVue>
    <ResMatchAbnormalDialog ref="resMatchAbnormalDialogRef"></ResMatchAbnormalDialog>
  </div>
</template>
<script>
import appointmentDialog from './components/appointmentDialog'
import carDialog from './components/carDialog'
import BatchAddMasterVue from './components/BatchAddMaster.vue'
import fileUpload from '@/views/oldForNewService/components/FileUpload.vue'
import { findOldMachineRecoveryList, cancelOrder, getPartner, getWarehouseList, hangupOrder, activateOrder } from '@/api/oldForNew'
import { orderStatusOption, recyclingStatusOption } from './mixin.js'
import ResMatchAbnormalDialog from '@/views/jdOldMachineRecycleManage/components/ResMatchAbnormalDialog.vue'
import enumMixin from '@/views/COldForNewService/enumMixin.js'
export default {
  name: 'order',
   mixins: [enumMixin],
  components: {
    appointmentDialog,
    carDialog,
    BatchAddMasterVue,
    fileUpload,
    ResMatchAbnormalDialog
  },
  filters: {},

  data() {
    return {
      list: [],
      optionList: {},
      total: null, //列表总条数
      listLoading: false,
      createdTime: [], //开始时间
      appointTime: [], //预约时间
      completeTime: [], //完成时间
      carrierOption: [], //承运商选项列表
      warehouseList: [], //归集仓仓库列表
      orderStatusOption: orderStatusOption, //订单状态
      recyclingStatusOption: recyclingStatusOption,
      search: {
        orderNo: null,
        status: null,
        networkNo: null,
        province: null, //省
        city: null, //市
        county: null, //区
        contact: null,
        tel: null,
        carrierNo: null,
        warehouseNo: null,
        createStartDate: null,
        createEndDate: null,
        appointStartDate: null,
        appointEndDate: null,
        completeStartDate: null,
        completeEndDate: null,
        regionName: null, //所属区域
        outboundNo: null, // 出库单号
        recoveryWorkerName: null, // 回收人员
        carrierOrg: null, //承运商所属组织
        currPage: 1, //当前页
        pageSize: 10,
        timeOutFlag: null,
        threeTimeOutFlag: null
      },
      provinceList: [], //省份列表
      cityList: [], //市列表
      countyList: [], //区域列表
      hasOldOPtion: { 1: '是', 0: '否' }, //是否有待回收旧机
      partnershipType: null, //当前用户所属组织 1 子公司 2 第三方 3 总公司
      downloadSettlementLoading: false,
      downloadOutboundLoading: false,
      statusText: null,
      HangupExcelBtnLoading: false,
      ActivateExcelBtnLoading: false
    }
  },
  computed: {
    tabsOption() {
      // 待派车,待预约,待上门,回收中,待填写车辆信息,运输中,待激活
      const list = orderStatusOption.filter((item) =>
        ["1", "2", "3", "4", "5", "6","10"].includes(item.value)
      );
      // list.forEach(item => {
      //   item.value
      // })
      return list
    }
  },
  watch: {
    'search.status'(newVal) {
      switch (newVal) {
        case '1':
          this.statusText = '1'
          break
        case '2':
          this.statusText = '2'
          break
        case '3':
          this.statusText = '3'
          break
        case '4':
          this.statusText = '4'
          break
        case '5':
          this.statusText = '5'
          break
        case '6':
          this.statusText = '6'
          break
        case '7':
        case '8':
        case '9':
          this.statusText = null
          break
        case '':
          this.statusText = '0'
          break
        case '10':
          this.statusText = '10'
          break
      }
      // if (newVal === '0') {
      //   this.search.status = null
      //   return
      // }
      // if (newVal) {
      //   this.search.status = Number(newVal)
      // }
    },
    statusText(newVal) {
      switch (newVal) {
        case '0':
          this.search.status = null
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = null
          break
        case '1':
          this.search.status = '1'
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = null
          break
        case '2':
          this.search.status = '2'
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = null
          break
        case '3':
          this.search.status = '3'
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = null
          break
        case '4':
          this.search.status = '4'
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = null
          break
        case '5':
          this.search.status = '5'
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = null
          break
        case '6':
          this.search.status = '6'
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = null
          break
        case '7':
          this.search.status = null
          this.search.timeOutFlag = 1
          this.search.threeTimeOutFlag = null
          break
        case '8':
          this.search.status = null
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = 1
          break
          case '10':
          this.search.status = '10'
          this.search.timeOutFlag = null
          this.search.threeTimeOutFlag = null
          break
      }
    }
  },
  async created() {
    this.getTblProvince()
    this.getPartnerList()
    this.getWarehouseList()
    this.getList()
    // 获取当前账号的组织类型
    this.partnershipType = JSON.parse(localStorage.getItem('partnershipType'))
  },
  methods: {
    async handleSearch() {
      this.search.currPage = 1
      this.getList()
    },

    changeStatus(value) {
      if (!value.status) {
        return ''
      }

      const statusLabel = this.getOptionLabel(this.orderStatusOption, value.status)
      if (!statusLabel) {
        return ''
      }

      if (value.recyclingStatus && value.status === 4) {
        const recyclingStatusLabel = this.getOptionLabel(this.recyclingStatusOption, value.recyclingStatus)
        if (recyclingStatusLabel) {
          return `${statusLabel} - ${recyclingStatusLabel}`
        }
      }

      return statusLabel
    },
    getOptionLabel(options, value) {
      const option = options.find(item => item.value == value)
      return option ? option.label : ''
    },

    async getList() {
      if (this.createdTime && this.createdTime.length) {
        this.search.createStartDate = this.createdTime[0]
        this.search.createEndDate = this.createdTime[1]
      } else {
        this.search.createStartDate = this.search.createEndDate = null
      }
      if (this.appointTime && this.appointTime.length) {
        this.search.appointStartDate = this.appointTime[0]
        this.search.appointEndDate = this.appointTime[1]
      } else {
        this.search.appointStartDate = this.search.appointEndDate = null
      }
      if (this.completeTime && this.completeTime.length) {
        this.search.recoveryCompleteStartDate = this.completeTime[0]
        this.search.recoveryCompleteEndDate = this.completeTime[1]
      } else {
        this.search.recoveryCompleteStartDate = this.search.recoveryCompleteEndDate = null
      }

      let { statusCode, data, total, message } = await findOldMachineRecoveryList(this.search)
      if (statusCode == 200) {
        this.list = data || []
        this.total = total || 0
      } else {
        this.$message.error(message)
      }
    },
    resetForm() {
      this.search = this.$options.data().search
      this.completeTime = this.appointTime = this.createdTime = []
    },
    //提交回收单
    goAdd(row) {
      this.$refs.AddDialogRef.openDialog(row, 'edit')
    },
    //车辆信息维护
    goCar(row) {
      this.$refs.carDialogRef.openDialog(row)
    },
    //获取省份列表
    getTblProvince() {
      this.search.city = ''
      this.search.county = ''
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-province/getTblProvince`).then(res => {
        if (res.statusCode === 200) {
          this.provinceList = res.data
        }
      })
    },
    //根据省份获取城市列表
    getTblCity() {
      this.search.city = ''
      this.search.county = ''
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-city/getTblCity?sfen=${this.search.province}`).then(res => {
        if (res.statusCode === 200) {
          this.cityList = res.data
        }
      })
    },
    //根据省市获取区域列表
    getTblCounty() {
      this.search.county = ''
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-county/getTblCounty?city=${this.search.city}`).then(res => {
        if (res.statusCode === 200) {
          this.countyList = res.data
        }
      })
    },
    handleSizeChange(val) {
      this.search.currPage = 1
      this.search.pageSize = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    //取消回收单
    goCancel(row) {
      if (row.orderNo) {
        this.$dialog({
          title: '温馨提示',
          content: '是否要取消该回收单，取消后不可以恢复！',
          cancel_buttton: '否',
          ok_buttton: '是',
          width: '400px',
          footBtn: 'card',
          dialogType: 'sighicon',
          onOk: () => {
            this.confirmCancel(row.orderNo)
            // const idList = [id];
            // this.HttpService.delete(
            //   `/autoapp-default-server-recovery/api/tbl-actual-price-control/deleteByIds?idList=${idList}`,
            //   {}
            // ).then(res => {
            //   if (res.statusCode === 200) {
            //     this.$message.success("删除成功");
            //     this.getList();
            //   } else {
            //     const tipMsg = res.message || "操作失败";
            //     this.$message.error(tipMsg);
            //   }
            // });
          },
          onCancel: () => {
            console.log('cancel')
          }
        })
      }
    },
    //确认取消
    async confirmCancel(orderNo) {
      let { statusCode, data } = await cancelOrder(orderNo)
      console.log('取消回收单操作', data)
    },
    //批量维护车辆信息
    batchAddMasterFun() {
      this.$refs.batchAddMasterRef.openDialog()
    },
    //跳转到详情页
    // goDetail(rowData) {
    //   this.$router.push({
    //     path: "/oldForNewService/orderDetail",
    //     query: {
    //       orderNo: rowData.orderNo
    //     }
    //   });

    // },
    goDetail(rowData) {
      window.open(`/oldForNewService/orderDetail?orderNo=${rowData.orderNo}`, '_blank')
    },
    //获取承运商
    async getPartnerList() {
      let { statusCode, data } = await getPartner()
      if (statusCode == 200) {
        this.carrierOption = data
        if (this.carrierOption.length && this.partnershipType !== 3) {
          this.search.carrierNo = this.carrierOption[0].carrierNo
        }
      }
    },
    //获取归集仓仓库列表
    async getWarehouseList() {
      let { statusCode, data } = await getWarehouseList()
      if (statusCode == 200) {
        this.warehouseList = data
      }
    },
    // 导出
    exportExcel() {
      if (this.createdTime && this.createdTime.length) {
        this.search.createStartDate = this.createdTime[0]
        this.search.createEndDate = this.createdTime[1]
      } else {
        this.search.createStartDate = this.search.createEndDate = null
      }
      if (this.appointTime && this.appointTime.length) {
        this.search.appointStartDate = this.appointTime[0]
        this.search.appointEndDate = this.appointTime[1]
      } else {
        this.search.appointStartDate = this.search.appointEndDate = null
      }
      if (this.completeTime && this.completeTime.length) {
        this.search.completeStartDate = this.completeTime[0]
        this.search.completeEndDate = this.completeTime[1]
      } else {
        this.search.completeStartDate = this.search.completeEndDate = null
      }
      let params = this.search
      const url = `/autoapp-default-server-recovery/api/oldMachineRecovery/exportOldMachineRecoveryList`
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 导出出库单
    exportOutboundNoExcel() {
      this.downloadOutboundLoading = true
      this.HttpService.post(`/autoapp-default-server-recovery/api/oldMachineRecovery/exportOldMachineRecoveryOutBoundPhotoCheck`, this.search).then(res => {
        if (res.statusCode === 200) {
          let url = '/autoapp-default-server-recovery/api/oldMachineRecovery/exportOldMachineRecoveryOutBoundPhoto'
          let title = '导出出库单.zip'
          this.bathDownload(url, this.search, title)
        } else {
          this.$message.error(res.message)
          this.downloadOutboundLoading = false
        }
      })
    },
    //下载单个结算单
    downloadSettlementById(orderNo) {
      this.global.exportExcel(`/autoapp-default-server-recovery/api/oldMachineRecovery/downloadExcel/${orderNo}`, '', '结算单下载').catch(res => {
        let blob = new Blob([res], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    //结算单压缩包导出
    downloadSettlement() {
      this.downloadSettlementLoading = true
      this.HttpService.post(`/autoapp-default-server-recovery/api/oldMachineRecovery/downloadBatchExcelCheck`, this.search).then(res => {
        if (res.statusCode === 200) {
          let url = '/autoapp-default-server-recovery/api/oldMachineRecovery/downloadBatchExcel'
          let title = '结算单批量导出.zip'
          this.bathDownload(url, this.search, title)
        } else {
          this.$message.error(res.message)
          this.downloadSettlementLoading = false
        }
      })
    },
    async bathDownload(url, data, filename = '发票.zip') {
      try {
        data = JSON.parse(JSON.stringify(data))
        const response = await this.HttpService({
          method: 'post',
          url: url,
          data,
          responseType: 'blob'
        })
        console.log('批量下砸', response)

        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          this.downloadSettlementLoading = false
          this.downloadOutboundLoading = false
        }
      } catch (err) {
        console.log(err)
        const reader = new FileReader()
        reader.onload = result => {
          if (!result.target || !result.target.result) {
            this.$message.warning({
              message: '下载不成功'
            })
          }
          this.$message.warning({
            message: '下载不成功',
            description: JSON.parse(result.target.result).message
          })
          this.downloadSettlementLoading = false
          this.downloadOutboundLoading = false
        }
        reader.readAsText(err.response.data)
      }
    },

    OldMachineBatchHangupExcel() {
      this.HangupExcelBtnLoading = true
      setTimeout(() => {
        this.HangupExcelBtnLoading = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/file/downLoadTemplate'
      const title = '批量挂起模板下载'
      this.global.exportExcel(url, { templateName: 'OldMachineBatchHangupExcel' }, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },

    OldMachineBatchActivateExcel() {
      this.ActivateExcelBtnLoading = true
      setTimeout(() => {
        this.ActivateExcelBtnLoading = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/file/downLoadTemplate'
      const title = '批量激活模板下载'
      this.global.exportExcel(url, { templateName: 'OldMachineBatchActivateExcel' }, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },

    handleHangupImport(item) {
      this.upLoadAbnormalData = item
      let formData = new FormData()
      formData.append('file', this.upLoadAbnormalData.file)
      let url = `/autoapp-default-server-recovery/api/oldMachine/batch/importHangup`
      this.HttpService.post(url, formData).then(res => {
        // console.log('===res===', res)
        if (res.statusCode === 200) {
          if (res.data) {
            let downloadId = res.data
            this.$refs.resMatchAbnormalDialogRef.opendDialog(downloadId)
          } else {
            this.$message.success('批量挂起导入成功')
            this.handleSearch()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleActivateImport(item) {
      this.upLoadAbnormalData = item
      let formData = new FormData()
      formData.append('file', this.upLoadAbnormalData.file)
      let url = `/autoapp-default-server-recovery/api/oldMachine/batch/importActivate`
      this.HttpService.post(url, formData).then(res => {
        // console.log('===res===', res)
        if (res.statusCode === 200) {
          if (res.data) {
            let downloadId = res.data
            this.$refs.resMatchAbnormalDialogRef.opendDialog(downloadId)
          } else {
            this.$message.success('批量激活导入成功')
            this.handleSearch()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 挂起订单
    handleHangup(row) {
      this.$dialog({
        title: '温馨提示',
        content: `确定要挂起订单 ${row.orderNo} 吗？`,
        cancel_buttton: '取消',
        ok_buttton: '确定',
        width: '400px',
        footBtn: 'card',
        dialogType: 'sighicon',
        onOk: async () => {
          try {
            let { statusCode, message } = await hangupOrder(row.orderNo)
            if (statusCode == 200) {
              this.$message.success('挂起成功')
              this.getList()
            } else {
              this.$message.error(message || '挂起失败')
            }
          } catch (error) {
            this.$message.error('挂起失败')
          }
        },
        onCancel: () => {
          console.log('cancel')
        }
      })
    },
    // 激活订单
    handleActivate(row) {
      this.$dialog({
        title: '温馨提示',
        content: `确定要激活订单 ${row.orderNo} 吗？`,
        cancel_buttton: '取消',
        ok_buttton: '确定',
        width: '400px',
        footBtn: 'card',
        dialogType: 'sighicon',
        onOk: async () => {
          try {
            let { statusCode, message } = await activateOrder(row.orderNo)
            if (statusCode == 200) {
              this.$message.success('激活成功')
              this.getList()
            } else {
              this.$message.error(message || '激活失败')
            }
          } catch (error) {
            this.$message.error('激活失败')
          }
        },
        onCancel: () => {
          console.log('cancel')
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
  display: flex;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
.batch-storage-button {
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/order.vue